import { Injectable } from '@angular/core';

import { BackendOberflaecheService, DownloadService, IDownloadService } from '@vhv/tarifrechner-common';
import { AppConfiguration } from '../app/app.configuration';
import { HttpHeaders } from '@angular/common/http';
import { SendeAntragsdatenCyberService } from './sende-antragsdaten-cyber.service';

@Injectable({
    providedIn: 'root',
})
export class DownloadCyberService implements IDownloadService {

    constructor(
        private downloadService: DownloadService,
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private appConfig: AppConfiguration,
        private sendeAntragsdatenCyberService: SendeAntragsdatenCyberService
    ) {
        this.downloadService.setDownloadService(this);
    }

    public getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }

    public getUrl(): string {
        return this.appConfig.restParentPath + this.appConfig.restPaths.pdfGebuendelterDownload.path;
    }

    public getDateiname() {
        return 'Sammeldokument_VHV_CYBERPROTECT.pdf';
    }

    public getFachdaten(): any {
        return this.sendeAntragsdatenCyberService.getDownloadRequest();
    }

    public getAntragskopie(): string {
        return null;
    }

    public setAntragskopie(jsonBlob: string) {
    }

    public getAntragskopieDateiname() {
        return 'VHV-CYBERPROTECT-Versicherungsschein.pdf';
    }

}
